module.exports = __webpack_public_path__ + "static/img/icon-hspmng-nodata.e6d8b58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hspmng/icon-hspmng-nodata.png
// module id = v93l
// module chunks = 1